module.exports = __webpack_public_path__ + "static/media/cerdo.def0eb1b.png";